import React, { useEffect, useState } from 'react';
import { Box, Breadcrumbs, CircularProgress, Link, Typography } from '@mui/material';
import { Link as RouterLink, useLocation, useParams } from 'react-router-dom';
import { getRouteWithParam, ROUTES } from '../../../../constants/routes';
import { useDispatch, useSelector } from 'react-redux';
import { getHistory, getTriggers } from '../../../../store/logging/actions';
import { HISTORY_HEAD_CELLS } from '../../../bonuses/constants';
import EnhancedTable from '../../../../components/EnhancedTable';
import { HistoryTableBody } from '../../components/HistoryTableBody';
import { visibleBySectionPermission } from '../../../../utils/visibleBySectionPermission';
import { PERMISSIONS } from '../../../../constants/variables';
import { setUsersPermissions } from '../../../../utils/setUsersPermissions';
import { getCities, getCMS, getPartnerById, getPartnersList } from '../../../../store/partners/actions';

export const History = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const { history, fetching, triggers } = useSelector((state) => state.logging);
  const { promotionCard, partnerCard , fetching: fetchingCard, cities, cms, partnersList } = useSelector((state) => state.partners);
  const { userPermissions, currentUsersPermissions } = useSelector((state) => state.userPermissions);
  const permissions = setUsersPermissions(userPermissions, currentUsersPermissions?.permissions);

  const [filter, setFilter] = useState({
    orderBy: 'created_at',
    orderType: 'desc',
    page: 0,
    size: 20,
  });

  const isPromotion = location.pathname.includes('promotion');

  useEffect(() => {
    dispatch(getHistory({
      ...filter,
      page: filter.page + 1,
      order_type: filter.orderType,
      order_by: filter.orderBy,
      instance_id: id,
      history_type: isPromotion ? 'partners_promotions' : 'partners'
    }));  // eslint-disable-next-line
  }, [
    filter.page,
    filter.orderType,
    filter.orderBy,
    filter.size
  ]);

  useEffect(() => {
    !cities.length && dispatch(getCities({ update: true }));
    !cms.length && dispatch(getCMS({ update: true }));
    !triggers.length && dispatch(getTriggers());
    !isPromotion && dispatch(getPartnerById(Number(id)));
    !partnersList.length && dispatch(getPartnersList());
  }, // eslint-disable-next-line
    []);

  const cmsPackage = isPromotion ? cms?.find(item => item?.id === promotionCard?.cms_package?.id) : undefined;

  const isPageVisible = visibleBySectionPermission(permissions, PERMISSIONS.LOGGING.ListHistory.value) &&
    ((isPromotion && visibleBySectionPermission(permissions, PERMISSIONS.PARTNER.retrievePartnerPromotions.value) &&
    visibleBySectionPermission(permissions, PERMISSIONS.PARTNERS.listPartners.value)) ||
    (!isPromotion && visibleBySectionPermission(permissions, PERMISSIONS.PARTNERS.retrievePartners.value)));

  if (!isPageVisible) return null;

  if (fetching || fetchingCard) {
    return (
      <Box
        sx={{
          marginTop: '150px',
          textAlign: 'center'
        }}>
        <CircularProgress data-testid="CircularProgress" />
      </Box>
    );
  }

  return (
    <Box>
      <Breadcrumbs mb="24px" aria-label="breadcrumb">
        <Link component={RouterLink} underline="hover" color="inherit" to={ROUTES.PARTNERS}>
          { isPromotion ? 'Партнёрские акции' : 'Партнёры' }
        </Link>
        <Link
          component={RouterLink}
          underline="hover"
          color="inherit"
          to={getRouteWithParam(isPromotion ? ROUTES.PARTNERS_DETAIL_PROMOTION : ROUTES.PARTNERS_DETAIL_PARTNER, ':id', id)}
        >
          {isPromotion ? cmsPackage?.name : partnerCard?.name}
        </Link>
        <Typography>История событий</Typography>
      </Breadcrumbs>
      <EnhancedTable
        rows={history?.items}
        headCells={HISTORY_HEAD_CELLS}
        filter={filter}
        total={history?.total || 0}
        fetching={fetching || fetchingCard}
        heightRow={77}
        setFilter={setFilter}
      >
        <HistoryTableBody data={history.items} isPromotion={isPromotion}/>
      </EnhancedTable>
    </Box>
  );
};
